import React from "react";

import { XIcon } from "@phosphor-icons/react";

import * as styles from "./styles";

export function Header({
  title,
  secondary = false,
  onClose,
}: {
  title: string;
  secondary?: boolean;
  onClose?: () => void;
}) {
  const handleOnClick = () => {
    onClose?.();
  };

  return (
    <div className={styles.container}>
      <span className={styles.title} data-secondary={secondary}>
        {title}
      </span>
      <button
        onClick={handleOnClick}
        className={styles.button}
        data-testid="poi-popup-content-header-close-button"
      >
        <XIcon className={styles.icon} weight="bold" />
      </button>
    </div>
  );
}
